import { User } from "../../../Domain/Model/User";
import AuthDataSource from "../AuthDataSource";

import axios from "axios";
import api from "../../../../../Shared/Config/AxiosInstance";
import { ApiResponse } from "../../../../../Shared/Model/ApiResponse";
import { UserDataStorage } from "../../../../../Shared/Storage/UserDataStorage";

const routeName = `/Account`;
export default class AuthAPIDataSource implements AuthDataSource{

  async login(email: string, password: string): Promise<User> {

    console.log("email", email);
     console.log("password", password);
    try {
      // Define los datos que deseas enviar en la petición POST
      const postData = {
        email: email,
        password: password,
      };
      const response = await api.post<ApiResponse<User>>(`${routeName}/authenticate`, postData);

      const { succeeded, message, data } = response.data;

       
      if (!succeeded || !data || !data.jwToken) {
        throw new Error(message || "Credenciales incorrectas");
      }

      // const statusToken = await this.checkAuthStatus(data.jwToken);
      // if (!statusToken) {
      //   throw new Error("Token inválido o expirado");
      // }
      UserDataStorage.save(data);

      return data;
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        const message =
          error.response?.data?.message ||
          "Error en la autenticación. Verifica tus credenciales.";
        throw new Error(message);
      }
       throw new Error(error.message || "Error desconocido al iniciar sesión");
    }
  }
  async checkAuthStatus(token: string): Promise<boolean> {
    try {
      const response = await api.post<ApiResponse<any>>(
        `${routeName}/auth/check-status`,
        null,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        }
      );

      return response.data.succeeded === true;
    } catch (error) {
      console.error("Error verificando el token:", error);
      return false;
    }
  }

}